var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQqPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.057 3.595L15.561 1.1a1.612 1.612 0 00-2.288 0l-2.688 2.683a1.618 1.618 0 000 2.293l2.1 2.102a9.504 9.504 0 01-2.025 2.983 9.522 9.522 0 01-2.981 2.03l-2.1-2.102a1.613 1.613 0 00-2.288 0l-2.69 2.683a1.618 1.618 0 000 2.293l2.494 2.493a2.806 2.806 0 002.423.78c3.103-.51 6.183-2.162 8.67-4.647 2.484-2.489 4.134-5.569 4.65-8.674a2.794 2.794 0 00-.781-2.423zm-.881 2.144c-.457 2.763-1.943 5.52-4.181 7.758-2.239 2.238-4.993 3.724-7.756 4.181a1.102 1.102 0 01-.956-.31l-2.45-2.448 2.597-2.6 2.808 2.813.021.02.507-.187a11.28 11.28 0 006.696-6.698l.187-.506-2.831-2.83 2.597-2.598 2.45 2.449c.252.253.37.61.31.956z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/qq_phone.0683a6179ff7256721fecf6c87ab7330.svg";
export { SvgQqPhone as ReactComponent };